import { useState } from "react";
import { EmailAutomationForm, EmailType } from "./EmailAutomationForm";
import { EmailTemplateEditor } from "@/components/email/EmailTemplateEditor";

function EmailAutomation() {
  const [selectedEmailType, setSelectedEmailType] = useState<EmailType | null>(null);
  const [isEditorOpen, setIsEditorOpen] = useState(false);

  const handleEditEmail = (emailType: EmailType) => {
    setSelectedEmailType(emailType);
    setIsEditorOpen(true);
  };

  const handleCloseEditor = () => {
    setIsEditorOpen(false);
    setSelectedEmailType(null);
  };

  const handleTemplateSaved = () => {
    // Optionally refresh the form data or show a success message
    console.log("Template saved successfully");
  };

  return (
    <div>
      <EmailAutomationForm onEditEmail={handleEditEmail} />
      
      {selectedEmailType && (
        <EmailTemplateEditor
          isOpen={isEditorOpen}
          onClose={handleCloseEditor}
          emailType={selectedEmailType}
          onSave={handleTemplateSaved}
        />
      )}
    </div>
  );
}

export default EmailAutomation;